module.exports = __webpack_public_path__ + "img/ad3.1f44109e.png";